module.exports = __webpack_public_path__ + "src/assets/games/21/545.jpg";